
import { defineComponent, ref, reactive, watch, nextTick, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue'
import { mapState, useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'

import COVERAPP from '@/utils/COVERAPP'

import MarkList from '@/utils/mark'

import gsap from 'gsap'

import Swiper from 'swiper/swiper-bundle'

import 'swiper/swiper-bundle.css'

export default defineComponent({
    computed: {
        ...mapState(['activityData', 'isCreating'])
    },
    setup (props, context) {
        const $store = useStore()
        const _this = getCurrentInstance() as any
        const $route = useRoute()
        const $router = useRouter()
        const COVER = _this.proxy.$common
        const isApp = ref<boolean>(false)
        const list = ref<any[]>(MarkList)
        const moveData = ref<any>({
            x: 0,
            y: 0,
            lastX: 0,
            lastY: 0,
            left: 0,
            top: 0,
            originalL: 0,
            originalT: 0
        })
        const seatList = ref<any[]>([
            {
                pos: [480, 200]
            },
            {
                pos: [50, 500]
            },
            {
                pos: [680, 600]
            },
            {
                pos: [300, 890]
            },
            {
                pos: [550, 1140]
            },
            {
                pos: [80, 1250]
            },
            {
                pos: [420, 1580]
            },
            {
                pos: [50, 1800]
            },
            {
                pos: [710, 1800]
            }
        ])
        const currentItem = ref<any>(null)
        let markSwiper = null as any

        let puzzleSwiper = null as any
        const puzzleSwiperInit = () => {
            puzzleSwiper = new Swiper('.puzzle-inner', {
                direction: 'vertical',
                slidesPerView: 'auto',
                freeMode: true,
                mousewheel: true,
                on:{
                    setTranslate: () => {
                        mapScroll(-puzzleSwiper.translate)
                    }
                }
            })
        }

        const mapLoad = (e) => {
            const size = e.target.width / e.target.naturalWidth
            seatList.value.forEach((val) => {
                val.pos = [val.pos[0] * size, val.pos[1] * size]
            })
            nextTick(() => {
                puzzleSwiperInit()
                mapScroll(0)
            })
            COVER.pageLoaded()
        }

        const selected = (index, event) => {
            event.preventDefault()
            if (!canFill()) return
            moveEndTimeId && clearTimeout(moveEndTimeId)
            list.value.forEach((val, i) => {
                if (i == index) {
                    val.selected = true
                } else {
                    val.selected = false
                }
            })
            const target = event.currentTarget as HTMLDivElement
            currentItem.value = JSON.parse(JSON.stringify(list.value[index]))
            currentItem.value.index = index
            const pageC = document.querySelector('.page-puzzle') as HTMLDivElement
            const originalL = target.getBoundingClientRect().left - pageC.getBoundingClientRect().left
            const originalT = target.getBoundingClientRect().top - pageC.getBoundingClientRect().top
            moveData.value = {
                x: 0,
                y: 0,
                lastX: event.touches[0].pageX,
                lastY: event.touches[0].pageY,
                left: originalL,
                top: originalT,
                originalL,
                originalT
            }
        }

        let timeId = 0
        const markMove = (index, event) => {
            event.preventDefault()
            timeId && clearTimeout(timeId)
            const target = event.currentTarget as HTMLDivElement
            let oldX = moveData.value.x
            let oldY = moveData.value.y
            let lastX = moveData.value.lastX
            let lastY = moveData.value.lastY
            let x = event.touches[0].pageX
            let y = event.touches[0].pageY
            let l = moveData.value.left
            let t = moveData.value.top
            moveData.value = {
                x: oldX + x - lastX,
                y: oldY + y - lastY,
                lastX: x,
                lastY: y,
                left: l + x - lastX,
                top: t + y - lastY,
                originalL: moveData.value.originalL,
                originalT: moveData.value.originalT
            }
            measureDistance(target.getBoundingClientRect(), list.value[index])
        }

        let fillIndex = -1
        let moveEndTimeId = 0
        const moveEnd = (index, event) => {
            timeId && clearTimeout(timeId)     
            let time = 0
            if (currentItem.value) {
                currentItem.value.isMoveEnd = true
                time = 500
                moveData.value.left = moveData.value.originalL
                moveData.value.top = moveData.value.originalT
            }
            moveEndTimeId = setTimeout(() => {
                list.value[index].selected = false
                currentItem.value = null
                moveData.value = {
                    x: 0,
                    y: 0,
                    lastX: 0,
                    lastY: 0,
                    left: 0,
                    top: 0,
                    originalL: 0,
                    originalT: 0
                }
            }, time) 
            fillIndex = -1
        }

        let disTime = 0
        const measureDistance = (obj, item) => {
            const seatItems = document.querySelectorAll('.puzzle-wrapper .puzzle-seat')
            for (let i = 0; i < seatItems.length; i++) {
                if (seatList.value[i].info || !seatList.value[i].isShow) {
                    continue
                }
                const itemNum = seatItems[i].getBoundingClientRect()
                const dx = (obj.left + obj.width / 2) - (itemNum.left + itemNum.width / 2)
                const dy = (obj.top + obj.height / 2) - (itemNum.top + itemNum.height / 2)
                const dis = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2))
                if (dis <= 30) {
                    if (fillIndex !== i) {
                        fillIndex = i
                        disTime = new Date().getTime()                   
                    } else if (disTime && new Date().getTime() - disTime > 100){
                        fillSeat(item, i, dx, dy)
                    }
                    timeId = setTimeout(() => {
                        fillSeat(item, i, dx, dy)
                    }, 100)
                    break
                }
            }
        }

        const fillSeat = (item, i: number, dx: number, dy: number) => {
            if (seatList.value[i].info || !seatList.value[i].isShow) {
                return
            }
            seatList.value[i].info = JSON.parse(JSON.stringify(currentItem.value))
            nextTick(() => {
                fillAni(i, dx, dy)
            })
            moveData.value = {
                x: 0,
                y: 0,
                lastX: 0,
                lastY: 0,
                left: 0,
                top: 0,
                originalL: 0,
                originalT: 0
            }
            item.isFilled = true
            currentItem.value = null
            setTimeout(() => {
                markSwiper.update()
                swiperIsEnd.value = markSwiper.isEnd
            }, 600)
        }

        const fillAni = (i, x, y) => {
            const seat = document.querySelectorAll('.puzzle-seat')[i] as HTMLDivElement
            const info = seat.querySelector('.info') as HTMLDivElement
            gsap.timeline().fromTo(info, {
                transform: `translate3d(${x}px, ${y}px, 0) scale(1)`,
            }, {
                transform: `translate3d(0, 0, 0) scale(2)`,
                ease: 'none',
                duration: .4,
            }).to(info ,{
                transform: `translate3d(0, 0, 0) scale(1)`,
                ease: 'none',
                duration: .4,
                delay: .2,
                onComplete: () => {
                    info.style.transform = ''
                    info.style.translate = ''
                    info.style.rotate = ''
                    info.style.scale = ''
                }
            })
        }

        const activeIndex = ref<number>(0)
        const swiperIsEnd = ref<boolean>(false)
        const initSwiper = () => {
            markSwiper = new Swiper('.mark-swiper', {
                slidesPerView : 'auto',
                slidesPerGroup : 3,
                noSwiping: true,
                on: {
                    slideChangeTransitionEnd () {
                        activeIndex.value = markSwiper.activeIndex
                        swiperIsEnd.value = markSwiper.isEnd
                    }
                },
            })
        }

        const prev = () => {
            markSwiper.slidePrev()
        }

        const next = () => {
            markSwiper.slideNext()
        }

        const ruleView = () => {
            $store.commit('SET_RULESHOW', true)
        }

        const lineView = () => {
            $store.commit('SET_LINESHOW', true)
        }

        const remove = (index: number, event) => {
            currentItem.value = JSON.parse(JSON.stringify(seatList.value[index].info))
            delete seatList.value[index].info
            const target = event.currentTarget.parentNode as HTMLDivElement
            moveData.value.x = 1
            moveData.value.left = target.getBoundingClientRect().left
            moveData.value.top = target.getBoundingClientRect().top
            let listIndex = currentItem.value.index
            let item = list.value[listIndex]
            let markItem = document.querySelectorAll('.mark-swiper .swiper-slide')[listIndex] as HTMLDivElement
            const pageC = document.querySelector('.page-puzzle') as HTMLDivElement
            setTimeout(() => {
                item.isReleased = true
                item.isFilled = false
                currentItem.value.isMoveEnd = true
                moveData.value.left = markItem.getBoundingClientRect().left - pageC.getBoundingClientRect().left
                moveData.value.top = markItem.getBoundingClientRect().top - pageC.getBoundingClientRect().top
            }, 0)
            setTimeout(() => {
                item.isReleased = false
                currentItem.value = null
                markSwiper.update()
                markSwiper.slideTo(listIndex)
                moveData.value = {
                    x: 0,
                    y: 0,
                    lastX: 0,
                    lastY: 0,
                    left: 0,
                    top: 0,
                    originalL: 0,
                    originalT: 0
                }
            }, 500) 
        }

        const mapScroll = (t: number) => {
            const inner = document.querySelector('.puzzle-inner') as HTMLDivElement
            const seat = document.querySelector('.puzzle-seat') as HTMLDivElement
            const seatH = seat.getBoundingClientRect().height
            const top = t - seatH / 3
            const bottom = top + inner.getBoundingClientRect().height - seatH / 3
            seatList.value.forEach((val) => {
                if (val.pos[1] > top && val.pos[1] < bottom) {
                    val.isShow = true
                } else {
                    val.isShow = false
                }
            })
        }

        const canFill = () => {
            let piece = 0
            let slideNoticeFlag = true
            seatList.value.forEach((val) => {
                if (val.info) {
                    piece++
                }
                if (val.isShow && !val.info) {
                    slideNoticeFlag = false
                }
            })
            if (piece >= 9) {
                $store.commit('SET_MESSAGEDATA', {
                    type: 2,
                    text: '最多能选9个景点'
                })
                return false
            }
            if (slideNoticeFlag) {
                $store.commit('SET_MESSAGEDATA', {
                    type: 1,
                    text: '上下滑动移动地图'
                })
                return false
            }
            return true
        }

        const create = () => {
            let piece = 0
            seatList.value.forEach((val) => {
                if (val.info) {
                    piece++
                }
            })
            if (piece < 3) {
                $store.commit('SET_MESSAGEDATA', {
                    type: 2,
                    text: '至少选3个景点'
                })
                return
            }
            if (piece > 9) {
                $store.commit('SET_MESSAGEDATA', {
                    type: 2,
                    text: '最多能选9个景点'
                })
                return
            }
            puzzleSwiper.setTranslate(0)
            $store.commit('SET_ISCREATING', true)
            nextTick(() => {
                createAni()
            })
            $store.commit('SET_MESSAGEDATA', {
                type: 3,
                text: '正在生成，请稍候...'
            })
            let imgList: any[] = []
            let tag: number[] = [0, 0, 0, 0, 0]
            seatList.value.forEach((val) => {
                if (val.info) {
                    tag[val.info.tag] += 1 
                    imgList.push({
                        info: val.info,
                        pos: val.pos
                    })
                }
            })
            let shareTag = 0
            if (piece === 9) {
                shareTag = 5
            } else {
                let maxTag = Math.max.apply(null, tag)
                for (let i = 0; i < tag.length; i++) {
                    if (tag[i] === maxTag) {
                        shareTag = i
                        break
                    }
                }
            }
            $store.commit('SET_SHAREIMGDATA', {
                tag: shareTag,
                imgList
            })
        }

        const createAni = () => {
            const tl = gsap.timeline()
            const inner = document.querySelector('.puzzle-inner') as HTMLDivElement
            const container = document.querySelector('.puzzle-container .swiper-slide') as HTMLDivElement
            const t = container.getBoundingClientRect().height - inner.getBoundingClientRect().height
            const people = document.querySelector('.people') as HTMLDivElement
            const containerAni = gsap.fromTo(container, {
                transform: `translate3d(0, 0, 0)`,
            }, {
                transform: `translate3d(0, -${t}px, 0)`,
                ease: 'none',
                duration: 11.5
            })

            tl.to(people, {
                transform: 'translate3d(-24vw, 42vw, 0)',
                ease: 'none',
                duration: 2
            })
            .to(people, {
                transform: 'translate3d(-18vw, 57vw, 0)',
                ease: 'none',
                duration: .5
            })
            .to(people, {
                transform: 'translate3d(16vw, 96vw, 0)',
                ease: 'none',
                duration: 3
            }).to(people, {
                transform: 'translate3d(16vw, 106vw, 0)',
                ease: 'none',
                duration: .5
            }).to(people, {
                transform: 'translate3d(-37vw, 130vw, 0)',
                ease: 'none',
                duration: 3
            }).to(people, {
                transform: 'translate3d(-37vw, 137vw, 0)',
                ease: 'none',
                duration: .5
            })
            .to(people, {
                transform: 'translate3d(-20vw, 172vw, 0)',
                ease: 'none',
                duration: 2
            })
            .to(people, {
                transform: 'translate3d(0, 0, 0)',
                ease: 'none',
                duration: 0,
                onComplete: () => {
                    $store.commit('SET_ISCREATING', false)
                    tl.clear()
                    people.style.transform = ''
                    people.style.translate = ''
                    people.style.rotate = ''
                    people.style.scale = ''
                    containerAni.kill()
                    container.style.transform = ''
                    container.style.translate = ''
                    container.style.rotate = ''
                    container.style.scale = ''  
                }
            })
        }

        onBeforeUnmount(() => {
            markSwiper && markSwiper.destroy()
        })

        onMounted(() => {
            isApp.value = COVERAPP.Attribute.isApp()
            nextTick(() => {
                initSwiper()
            })
            COVER.track('load', $store.state.activityData.title)
            COVER.onshare($store.state.shareData)
        })    

        return {
            list,
            seatList,
            currentItem,
            moveData,
            activeIndex,
            swiperIsEnd,
            mapLoad,
            selected,
            markMove,
            moveEnd,
            prev,
            next,
            ruleView,
            lineView,
            remove,
            create
        }
    }
})
